import { Button, Col, InputNumber, Row } from 'antd';
import React from 'react';
import { ReactSVG } from 'react-svg';
import './Pricing.scss';

const RangeInput = ({ minValue, maxValue, price, onUpdate }) => {
  return (
    <Row gutter={8} className="price-range-row">
      <Col span={7}>
        <InputNumber
          size="large"
          style={{ width: '100%' }}
          value={minValue}
          min={minValue}
          onChange={(value) => onUpdate({ minOrders: value })}
        />
      </Col>
      <Col span={1}>
        <div className="line-wrapper">
          <div className="line"></div>
        </div>
      </Col>
      <Col span={7}>
        <InputNumber
          size="large"
          style={{ width: '100%' }}
          value={maxValue}
          onChange={(value) => onUpdate({ maxOrders: value })}
        />
      </Col>
      <Col span={1}></Col>
      <Col span={8}>
        <InputNumber
          size="large"
          addonAfter="€"
          value={price}
          min={0}
          onChange={(value) => onUpdate({ price: value })}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  );
};

const PricingRange = ({ orderType, onAddRange, onDeleteRange, updateRangeValue, pricingRanges, isValid }) => {
  return (
    <div className="pricing-ranges">
      <Row gutter={8}>
        <Col span={16}>
          <h5 className="verticalCenter">{orderType}</h5>
        </Col>
        <Col span={4}>
          <Button onClick={() => onDeleteRange(orderType)} disabled={pricingRanges?.length <= 1 ? true : false}>
            <ReactSVG className="small" src="/icons/delete.svg" />
          </Button>
        </Col>
        <Col span={4}>
          <Button
            onClick={() => onAddRange(orderType)}
            disabled={pricingRanges[pricingRanges?.length - 1]?.maxOrders === null}
          >
            <ReactSVG className="small" src="/icons/plus.svg" />
          </Button>
        </Col>
        <Col span={8}>
          <p>Minimum Orders</p>
        </Col>
        <Col span={8}>
          <p>Maximum Orders</p>
        </Col>
        <Col span={8}>
          <p>Price</p>
        </Col>
        {Array.from({ length: pricingRanges.length }, (_, index) => (
          <RangeInput
            key={index}
            minValue={pricingRanges[index].minOrders}
            maxValue={pricingRanges[index].maxOrders}
            price={pricingRanges[index].price}
            onUpdate={(updatedValue) => updateRangeValue(index, orderType, updatedValue)}
          />
        ))}
        {!isValid[orderType] && (
          <>
            <Col span={7}></Col>
            <Col span={17}>
              <p style={{ color: 'red' }}>Invalid range or price</p>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default PricingRange;
